import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=14bada27&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&id=14bada27&scoped=true&lang=css&"
import style1 from "./Tambah.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bada27",
  null
  
)

export default component.exports